import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import { BusinessSummary, Dashboard, Invoices, Ledger, Login, Outstanding, Profile, Business, MakePayment, HandlePayment, PaymentSuccess, PaymentError, Home, About, Privacy, Cancellation, Shipping, ProductCategory, Product, ProductList, ContactDetails, BankDetails, Receipts, Orders, BankCheques, OrderDetails } from './Pages';
import '../../node_modules/bootstrap/dist/css/bootstrap.css';
import '../../node_modules/bootstrap/dist/js/bootstrap.js';
import '../scss/style.scss'
import 'bootstrap'
import logo from "../assets/logo.png"
import { ActionCreators } from '../store/actionCreators';
import { RootState } from 'store/store';
import { BottomBar } from './Widgets';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { COMPANY_NAME } from 'service/Models';
import { NewOrder } from './Pages/NewOrder';

function App() {
  const user = useSelector((state: RootState) => state.appdata);
  const dispatch = useDispatch();

  const checkLocalStorage = () => {
    console.log("Checking local storage");
    let user_data = localStorage.getItem("user");
    if (user_data && user_data.length > 0) {
      let login_time = localStorage.getItem("login_time");
      if (login_time && login_time.length > 0) {
        let last_login_time = moment(login_time);
        if (moment().diff(last_login_time, 'days') === 0) {
          let user_info = JSON.parse(user_data);
          dispatch(ActionCreators.login(user_info));
        }
      }
    }
  }

  const isAuthenticated = () => {
    if (!user.isUserLoggedIn) {
      checkLocalStorage();
      if (!user.isUserLoggedIn) {
        return false;
      }
    }
    return true;
  }

  const PrivateRoute = ({ children }) => isAuthenticated() ? children : <Login />

  return (
    <div id="app">
      <Router>
        {user.isUserLoggedIn &&
          <nav className="navbar">
            <div className="container">
              <a className="navbar-brand w-100 text-center" href="/">
                <img src={logo} height="30" alt="" style={{ marginRight: 5 }} />
              </a>
            </div>
          </nav>
        }
        <div className="container">
          <div className="row" style={{ marginBottom: 40 }}>
            <Routes>
              <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/invoice" element={<PrivateRoute><Invoices /></PrivateRoute>} />
              <Route path="/order" element={<PrivateRoute><Orders /></PrivateRoute>} />
              <Route path="/receipt" element={<PrivateRoute><Receipts /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
              <Route path="/business" element={<PrivateRoute><Business /></PrivateRoute>} />
              <Route path="/businessSummary" element={<PrivateRoute><BusinessSummary /></PrivateRoute>} />
              <Route path="/outstanding" element={<PrivateRoute><Outstanding /></PrivateRoute>} />
              <Route path="/payment" element={<PrivateRoute><MakePayment /></PrivateRoute>} />
              <Route path="/payment/result" element={<PrivateRoute><HandlePayment /></PrivateRoute>} />
              <Route path="/payment/success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />
              <Route path="/order/new" element={<PrivateRoute><NewOrder /></PrivateRoute>} />
              <Route path="/order/:id" element={<PrivateRoute><OrderDetails /></PrivateRoute>} />
              <Route path="/login" element={<Login />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/cancellation" element={<Cancellation />} />
              <Route path="/shipping" element={<Shipping />} />
              <Route path="/productCategory" element={<ProductCategory />} />
              <Route path="/bank" element={<BankDetails />} />
              <Route path="/contact" element={<ContactDetails />} />
              <Route path="/bankCheques" element={<PrivateRoute><BankCheques /></PrivateRoute>} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/product/:id" element={<Product />} />
            </Routes>
          </div>
        </div>
        {user.isUserLoggedIn &&
          <BottomBar />
        }
      </Router>
    </div>
  );
}

export default App;
